<template>
<div class="" :class="{'now_loading': (this.loading)}">
  <SelectItem :selectItem="detailItem" />
  <div v-show="loading" class="loader loader_bg--gray"></div>
  <div v-show="!loading" v-for="(value, index) in productsList" class="products_wrap bg_white mt12 pt16 pb24 boxs1" :key="value.genreId">
    <h2 class="content_title" :class="[value.genreId == 100 ? 'orange' : '', ]">{{ value.genreName }}</h2>
    <div class="product_list">
      <div v-for="(val, n) in value.itemList" class="product_item" :class="{ 'select': checkProductInTheCart(val.product.productId) }" @click="selectItem(val)" :key="val.product.productName">
        <div class="products_main">
          <div class="product_image">
            <img :src="imagePath + val.product.imagePath" :alt="val.product.productName" @error="imageError" :data-noimage="imagePath + val.product.noImagePath">
          </div>
          <h3 class="product_title">{{ val.product.productName }}</h3>
        </div>
        <div class="products_detail">
          <p class="product_price rb"><span class="yen">￥</span>{{ val.product.price.toLocaleString() }}</p>
          <p v-if="val.product.point != 0" class="product_point rb"><span class="point">P</span>{{ val.product.point.toLocaleString() }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SelectItem from '@/components/n-selection/SelectItem';
import Product from '@/components/api/n-selection/n-selection';
import scrollPosition from '@/model/scrollPosition';
import Config from '@/config/config';
import ProductFunction from '@/model/n-selection/selectProducts'

export default {
  components: {
    SelectItem
  },
  data() {
    return {
      imagePath: Config.APIURL,
      select: null,
      loading: true,
      // productList: [],
      detailItem: null,
      isOpen: false,
    }

  },
  methods: {
    checkProductInTheCart(productId) {
      return this.nselectionOrderList.some((product) => product.productId == productId);
    },
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    selectItem(data) {
      scrollPosition.open();
      this.select = data.product.productId;
      this.detailItem = data;
      this.$store.commit('nselection/setSelectItemIsOpen', true);
    },

    async apiGetProductList() {
      this.loading = true;
      await Product.getProductList().then((val) => {
        // this.productList.splice(0, this.productList.length); // 配列の初期化
        this.$store.commit('nselection/setCurrentMonth', val.productList[0].currentOrderMonth);
        for (var i = 0; i < val.genreList.length; i++) {
          let items = {
            genreId: val.genreList[i].genreId,
            genreName: val.genreList[i].genreName,
            itemList: []
          }
          for (var a = 0; a < val.productList.length; a++) {
            if(val.genreList[i].genreId == val.productList[a].product.genre.genreId) {
              items.itemList.push(val.productList[a]);
            }
          }
          if (items.itemList.length != 0) {
            // this.productList.push(items);
            this.$store.commit('nselection/setProductsList', items);
          }
        }
        this.loading = false;
        this.$store.commit('nselection/setCartIsDisabled', false);
      });
    },
    initialized() {
      this.$store.commit('nselection/setCartIsDisabled', true);
      this.$store.dispatch('nselection/initializedProductsList');
    },
  },
  computed: mapGetters(
    'nselection', ['productsList', 'currentMonth', 'selectItemIsOpen', 'nselectionOrderList'],
  ),
  async created() {
    this.initialized();
    await this.apiGetProductList();
  },
}

</script>

<style lang="css" scoped>
.orange {
  background-color: #FFA800;
}
</style>



// WEBPACK FOOTER //
// src/components/n-selection/ProductsList.vue